import { render, staticRenderFns } from "./SchoolBrand.vue?vue&type=template&id=0c5088a8&scoped=true"
import script from "./SchoolBrand.vue?vue&type=script&lang=js"
export * from "./SchoolBrand.vue?vue&type=script&lang=js"
import style0 from "./SchoolBrand.vue?vue&type=style&index=0&id=0c5088a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5088a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5088a8')) {
      api.createRecord('0c5088a8', component.options)
    } else {
      api.reload('0c5088a8', component.options)
    }
    module.hot.accept("./SchoolBrand.vue?vue&type=template&id=0c5088a8&scoped=true", function () {
      api.rerender('0c5088a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/SchoolBrand.vue"
export default component.exports